/**
 * BlogPosting JSON-LD for a blog post, shared by the client head
 * (src/utils/blogSeo.js applyBlogPostSeo) and the prerendered head
 * (src/seo/crawlerShell.js schemasForRoute), both under the script id
 * `blog-jsonld-article`, so hydration replaces the prerendered block.
 * Built only from the post data the page shows (docs/SEO_BLOG_CTR_1028.md).
 */
import { blogPostUrl } from '../data/blogPosts';
import { SITE, canonicalUrl } from './urls';

/** Editorial byline + JSON-LD author (organization, not a named individual). */
export const BLOG_AUTHOR = {
  name: 'CFA Mock Exam Team',
  url: `${SITE}/`,
  type: 'Organization',
};

export function blogPostingSchema(post) {
  const url = blogPostUrl(post.slug);
  return {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: post.title,
    description: post.metaDescription,
    datePublished: post.published,
    dateModified: post.updated || post.published,
    author: {
      '@type': BLOG_AUTHOR.type,
      name: BLOG_AUTHOR.name,
      url: BLOG_AUTHOR.url,
    },
    publisher: { '@id': `${SITE}/#organization` },
    mainEntityOfPage: { '@type': 'WebPage', '@id': url },
    url,
    image: `${SITE}/og.png`,
    keywords: post.keywords?.join(', '),
    articleSection: 'CFA Level 1',
    inLanguage: 'en',
    isPartOf: { '@id': `${canonicalUrl('/blog')}#blog` },
  };
}
